import { useMemo } from "react";
import { useIntl } from "react-intl";

type DisplayItemsProps = {
  itemLabel: string;
  limit: number;
  totalItems: number;
}

export default function DisplayItems ({itemLabel, limit, totalItems}: DisplayItemsProps) {
  const intl = useIntl();
  const displayItems = useMemo(() => {
    if (!limit || !totalItems) return 0;

    return totalItems <= limit ? totalItems : limit;
  }, [limit, totalItems])
  
  return (
    <div className="mb-7 flex justify-between items-center gap-5 text-sm text-shadow">
      <span className="font-bold">{totalItems} {itemLabel}</span>
      <span className="font-normal">
        {intl.formatMessage({ id: 'common.displayResults' }, { count: displayItems })}
      </span>
    </div>
  )
}
